import React, { useState } from "react";
import ic_job_creation_success from "../img/ic_job_creation_success.png";
import "../css/Create_customer_popup.css";
import axios from "axios";
import Common_loader from "./Common_loader";

function Create_customer_popup(props) {

    const { closePopupUserCreation, closePopupAfterSuccessfulUserCreation, setErrorMessage,mobileNumberSearched} = props;

    console.log("mobileNumberSearched is ", mobileNumberSearched);

    const [isCallingAPI, setIsCallingAPI] = useState(false);


    let initialUserObject = {
        customer_name: "",
        customer_address1: "",
        customer_address2: "",
        mobile_no: mobileNumberSearched,
        email: "",
        TRN: "",
        username: " - "
    }

    const [userObjectState, setUserObjectState] = useState(initialUserObject);

    const createNewUser = () => {

        let objectToSendToAPI = {
            customer_name: userObjectState.customer_name,
            customer_address1: userObjectState.customer_address1,
            customer_address2: userObjectState.customer_address2,
            mobile_no: userObjectState.mobile_no,
            email: userObjectState.email,
            TRN: userObjectState.TRN,
            username: " - "
        }

        if (objectToSendToAPI.customer_name.length == 0) {

            setErrorMessage("customer name required")

        } else if (objectToSendToAPI.customer_address1.length == 0) {
            setErrorMessage("customer address 1 required")
        } else if (objectToSendToAPI.customer_address2.length == 0) {
            setErrorMessage("customer address 2 required")
        } else if (objectToSendToAPI.mobile_no.length == 0) {
            setErrorMessage("customer mobile number required")
        }   else {
            setIsCallingAPI(true)

            console.log(" calling API objectToSendToAPI is ", objectToSendToAPI)
            axios.post(`${process.env.REACT_APP_BACK_END_BASE_URL}/Customer_registration`, [objectToSendToAPI]).then((res) => {

                setIsCallingAPI(false)

                console.log("customer creation res is ", res)
                if (res.data.result == "Saved") {
                    closePopupAfterSuccessfulUserCreation();
                }

            }).catch((err) => {
                setIsCallingAPI(false)
                console.log("err is ", err)
                setErrorMessage("Something went wrong, Please try later")
            })
        }

    }

    const handleInput = (e) => {
        setUserObjectState(prev => ({ ...prev, [e.target.name]: e.target.value }))
    }

    return (
        <div className="Create_customer_popup_root_container">
            <h6>Create Customer</h6>

            <div className="Create_customer_popup_root_container_input_field_containers mt-4">
                <label>Customer name</label>
                <input type="text" name="customer_name" className="CreateNewJob_Add_service_popup_type_box" onChange={(e) => handleInput(e)} />
                <label className="mt-4">Customer Address 1</label>
                <input type="text" name="customer_address1" className="CreateNewJob_Add_service_popup_type_box" onChange={(e) => handleInput(e)} />
                <label className="mt-4">Customer Address 2</label>
                <input type="text" name="customer_address2" className="CreateNewJob_Add_service_popup_type_box" onChange={(e) => handleInput(e)} />
                <label className="mt-4">Mobile Number</label>
                <input type="text" name="mobile_no" className="CreateNewJob_Add_service_popup_type_box" value={userObjectState.mobile_no} onChange={(e) => handleInput(e)} />
                <label className="mt-4">Email</label>
                <input type="text" name="email" className="CreateNewJob_Add_service_popup_type_box" onChange={(e) => handleInput(e)} />
                <label className="mt-4">TRN</label>
                <input type="text" name="TRN" className="CreateNewJob_Add_service_popup_type_box" onChange={(e) => handleInput(e)} />
            </div>

            <div className="Create_customer_popup_button_container">
                <button className="common_close_button mt-4" onClick={() => closePopupUserCreation()}>Cancel</button>
                <button className="common_grey_button mt-4" onClick={() => createNewUser()}>Create</button>
            </div>

            {
                isCallingAPI &&
                <Common_loader />
            }

        </div>
    )
}

export default Create_customer_popup;